/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SigningTokenStatusEnum } from './SigningTokenStatusEnum';

export type SigningStatusEntry = {
    tokenId: string;
    signerName?: (string | null);
    signerEmail?: (string | null);
    blockIds?: (Array<string> | null);
    status: SigningTokenStatusEnum;
    linkType?: SigningStatusEntry.linkType;
    createdAt: string;
    usedAt?: (string | null);
    signingUrl?: (string | null);
};

export namespace SigningStatusEntry {

    export enum linkType {
        TOKEN = 'token',
        DIRECT = 'direct',
    }


}

